import React, { useState, useEffect, useRef } from "react";
import useTable from "../components/useTable";
import { Mensaje, MensajeSiNo } from "../components/mensajes";
import { Dimmer } from "../components/spinner";
import axios from "axios";
import moment from "moment";
import { Toasts } from "../components/toasts";
import { ModalTimbreDependencias } from "../components/timbre_fiscal_electronico/modal_timbre_dependencias";

function TimbreDependencias() {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const cruddependencia = JSON.parse(localStorage.getItem("cruddependencia"));

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [tab, setTab] = useState(1);
  const [records, setRecords] = useState([]);
  const [entes, setEntes] = useState([]);
  const [operacion, setOperacion] = useState(null);
  const [activate, setActivate] = useState(false);
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const [mostrar2, setMostrar2] = useState(false);
  const [dependencia, setDependencia] = useState(null);

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DEPENDENCIA",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "ENTE",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "",
      textAlign: "center",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.iddependencia.toString().includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.ente.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const estilos = {
    tab: {
      borderBottomLeftRadius: 0.25,
      borderBottomRightRadius: 0.25,
      border: "solid rgba(5, 81, 130, 1)",
      borderBottom: "none",
    },
    contenido: {
      border: "solid rgba(5, 81, 130, 1)",
    },
  };

  const seleccionarRegistros = () => {
    let campos = "d.*, e.tipo as ente";
    let nomtab =
      "dependencias as d inner join tipoente as e on d.tipoente=e.idtipoente";
    let orden = "iddependencia desc";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          } else {
            setRecords([]);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarEntes = () => {
    let campos = "*";
    let nomtab = "tipoente";
    let orden = "idtipoente desc";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setEntes(response.data);
          } else {
            setEntes([]);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistro = (iddependencia) => {
    let campos = "*";
    let nomtab = "dependencias";
    let nomid = "iddependencia";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${iddependencia}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setDependencia(response.data);
            setMostrar2(true);
          } else {
            setDependencia(null);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    setActivate(true);
  };

  const ocultarModal = (p) => {
    if (p === 1) {
      seleccionarRegistros();
    }
    setMostrar2(false);
  };

  const cerrarModal = () => {
    seleccionarRegistros();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const gestionarSolicitud = (op, id) => (e) => {
    e.preventDefault();

    setOperacion(op);
    if (op === 1) {
      if (cruddependencia.substring(1, 2) !== "0") {
        setMostrar2(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (cruddependencia.substring(2, 3) !== "0") {
        seleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (cruddependencia.substring(3, 4) !== "0") {
        seleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 4) {
      if (cruddependencia.substring(0, 1) !== "0") {
        seleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    }
  };

  useEffect(() => {
    seleccionarRegistros();
    seleccionarEntes();
  }, []);

  return (
    <div className="">
      <div
        className="p-2 title-table"
        style={{
          fontFamily: "georgia",
          textAlign: "center",
          fontSize: "30px",
          fontWeight: "bold",
        }}
      ></div>
      <div className="container col-md-11 col-12 amanecergris mx-auto">
        <div className="row py-2 col-md-12">
          <div className="col-md-12 mx-auto">
            <ul
              className="nav nav-tabs"
              id="ex-with-icons"
              role="tablist"
              style={{ borderRadius: "3px 3px 0px 0px" }}
            >
              <li
                className="nav-item"
                onClick={() => setTab(1)}
                role="presentation"
              >
                <a
                  className="nav-link bg-danger estilotab p-2"
                  style={tab === 1 ? estilos.tab : {}}
                  id="ex-with-icons-tab-1"
                  data-mdb-toggle="tab"
                  href="#ex-with-icons-tabs-1"
                  role="tab"
                  aria-controls="ex-with-icons-tabs-1"
                  aria-selected="true"
                >
                  <i className="fas fa-pager fa-fw me-1" />
                  Dependencias
                </a>
              </li>
            </ul>

            <div
              className="tab-content"
              id="ex-with-icons-content"
              style={tab === 1 ? estilos.contenido : {}}
            >
              <div
                className="tab-pane fade show active"
                id="ex-with-icons-tabs-1"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-1"
              >
                <div className="card text-center">
                  <div className="card-body">
                    <div className="col-md-12 row was-validated">
                      <div className="row col-12 d-flex justify-content-between">
                        <input
                          type="text"
                          className="m-0 col-3 form-control form-control-sm rounded-pill"
                          ref={txtBuscador}
                          onChange={handleSearch}
                          placeholder="Buscar"
                        />
                        <div className="col-3 d-flex justify-content-end">
                          <button
                            onClick={gestionarSolicitud(1, "")}
                            className={
                              cruddependencia.substring(1, 2) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-primary rounded-circle"
                            }
                          >
                            <i className="fa fa-plus"></i>{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row py-2">
                      {
                        <div className="col-md-12 pt-3">
                          <TblContainer
                            container={{
                              maxHeight: 180,
                              width: "100%",
                              overflow: "auto",
                            }}
                          >
                            <TblHead />
                            <tbody>
                              {records &&
                                recordsAfterPagingAndSorting().map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td
                                        className="align-baseline text-start"
                                        style={{ border: "#055182 solid 1px" }}
                                      >
                                        {item.nombre}
                                      </td>
                                      <td
                                        className="align-baseline text-start"
                                        style={{ border: "#055182 solid 1px" }}
                                      >
                                        {item.ente}
                                      </td>
                                      <td
                                        className="align-baseline text-center"
                                        style={{
                                          border: "#055182 solid 1px",
                                          width: 120,
                                        }}
                                      >
                                        <button
                                          onClick={gestionarSolicitud(
                                            4,
                                            item.iddependencia
                                          )}
                                          className={
                                            cruddependencia.substring(0, 1) ===
                                            "0"
                                              ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                              : "btn btn-sm mx-1 btn-info rounded-circle"
                                          }
                                        >
                                          <i className="fa fa-eye"></i>{" "}
                                        </button>
                                        <button
                                          onClick={gestionarSolicitud(
                                            2,
                                            item.iddependencia
                                          )}
                                          className={
                                            cruddependencia.substring(2, 3) ===
                                            "0"
                                              ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                              : "btn btn-sm mx-1 btn-success rounded-circle"
                                          }
                                        >
                                          <i className="fa fa-edit"></i>{" "}
                                        </button>
                                        <button
                                          onClick={gestionarSolicitud(
                                            3,
                                            item.iddependencia
                                          )}
                                          className={
                                            cruddependencia.substring(3, 4) ===
                                            "0"
                                              ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                              : "btn btn-sm mx-1 btn-danger rounded-circle"
                                          }
                                        >
                                          <i className="fa fa-trash"></i>{" "}
                                        </button>
                                      </td>
                                    </tr>
                                  )
                                )}
                            </tbody>
                          </TblContainer>
                          <TblPagination />
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={() =>
          setToast({ mostrar: false, titulo: "", mensaje: "" })
        }
      />
      <ModalTimbreDependencias
        show={mostrar2}
        operacion={operacion}
        entes={entes}
        dependencia={dependencia}
        onHide={ocultarModal}
      />
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
}

export default TimbreDependencias;



// WEBPACK FOOTER //
// ./src/pages/timbre_dependencias.js